// removed by extract-text-webpack-plugin
module.exports = {"component":"uk2rng8svBHbPlM05Nkjp","loginPic":"_1BwNdAWM3wl7JbtMGhEksO","loginMes":"Ta8GQiEyq1Mcrf3uLxas-","loginH1":"_3OJe3ajdf4jixT5-y2IxPB","bottomContainer":"_1o36YaWemLLhV86tRan9vA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ShopAnnouncement/ShopAnnouncement.scss
 ** module id = 1095
 ** module chunks = 0
 **/